<template>
  <div class="scs">
    <header class="scs__hero">
      <p class="scs__eyebrow">HAMWOORI / NEW CONTRACT</p>
      <h1 class="scs__title">새 계약서</h1>
      <p class="scs__lead">
        함우리 정보와 별첨 2를 먼저 정합니다.
        여기서 적은 내용은 「계약서 작성」 이후 피계약자에게 그대로 보이고, 그 화면에서는 고치지 않습니다.
      </p>
    </header>

    <form class="scs__main" @submit.prevent>
      <section class="scs__card">
        <h2 class="scs__h">함우리 정보</h2>
        <p class="scs__hint">계약서의 을 자리에 들어갑니다. 기본값을 그대로 두거나 이 계약에 맞게 고칩니다.</p>
        <label class="scs__label" for="scs-b-name">상호</label>
        <input id="scs-b-name" v-model="form.partyBLegalName" class="scs__input" type="text" />
        <div class="scs__row">
          <div>
            <label class="scs__label" for="scs-b-biz">사업자등록번호</label>
            <input id="scs-b-biz" v-model="form.partyBBizNumber" class="scs__input" type="text" />
          </div>
          <div>
            <label class="scs__label" for="scs-b-owner">대표자</label>
            <input id="scs-b-owner" v-model="form.partyBOwner" class="scs__input" type="text" />
          </div>
        </div>
        <label class="scs__label" for="scs-b-addr">소재지</label>
        <input id="scs-b-addr" v-model="form.partyBAddress" class="scs__input" type="text" />
        <div class="scs__row">
          <div>
            <label class="scs__label" for="scs-b-phone">연락처</label>
            <input id="scs-b-phone" v-model="form.partyBPhone" class="scs__input" type="text" />
          </div>
          <div>
            <label class="scs__label" for="scs-b-org">담당조직</label>
            <input id="scs-b-org" v-model="form.partyBOrg" class="scs__input" type="text" />
          </div>
        </div>
      </section>

      <section class="scs__card">
        <h2 class="scs__h">별첨 2</h2>
        <p class="scs__hint">
          피계약자에게 보일 문서 모양 그대로 적습니다. ☑와 밑줄 칸을 누르면 그 자리에서 입력됩니다.
          양식에 없는 계약이면 텍스트로 적습니다.
        </p>
        <div class="scs__modes" role="radiogroup" aria-label="별첨 2 작성 방식">
          <button
            type="button"
            class="scs__mode"
            :class="{ 'is-on': form.annex2Mode !== 'text' }"
            @click="form.annex2Mode = 'form'"
          >
            양식대로 작성
          </button>
          <button
            type="button"
            class="scs__mode"
            :class="{ 'is-on': form.annex2Mode === 'text' }"
            @click="form.annex2Mode = 'text'"
          >
            텍스트로 작성
          </button>
        </div>
        <div class="sc__panel scs__doc">
          <div class="sc__topline" />
          <p class="sc__doctype">별첨 2</p>
          <h2>서비스 요금·청구 및 정산 합의서</h2>
          <ServiceContractAnnex2Doc :form="form" />
        </div>
      </section>

      <div class="scs__foot">
        <button type="button" class="scs__btn scs__btn--ghost" @click="emit('back')">목록</button>
        <button type="submit" class="scs__btn scs__btn--teal" @click="onContinue">계약서 작성</button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import ServiceContractAnnex2Doc from '@/components/contract/ServiceContractAnnex2Doc.vue'
import type { ServiceContractForm } from '@/composables/useServiceContractForm'

const props = defineProps<{
  form: ServiceContractForm
}>()

const emit = defineEmits<{
  back: []
  continue: []
}>()

function onContinue() {
  const wroteAnnex2 = props.form.annex2Mode === 'text'
    ? props.form.annex2Text.trim().length > 0
    : Boolean(props.form.wageFee || props.form.acctFee || props.form.monthlyTotal.trim())
  if (wroteAnnex2) props.form.annexAgreed.a2 = true
  emit('continue')
}
</script>

<style lang="scss" src="./ContractSetup.scss"></style>
